export default "__VITE_ASSET__DrjWiMHs__";